export default __webpack_public_path__ + "static/media/favonius_lance.693335d4.png";